var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImagePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 63 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.25.75h-55A3.75 3.75 0 00.5 4.5v45a3.75 3.75 0 003.75 3.75h55A3.75 3.75 0 0063 49.5v-45A3.75 3.75 0 0059.25.75zm-55 2.5h55A1.25 1.25 0 0160.5 4.5v35.125L50.222 29.347a3.751 3.751 0 00-5.313 0l-7.134 7.134-14.631-14.634a3.75 3.75 0 00-5.313 0L3 36.687V4.5a1.25 1.25 0 011.25-1.25zM3 49.5v-9.269l16.616-16.615a1.25 1.25 0 011.768 0L48.52 50.75H4.25A1.25 1.25 0 013 49.5zm56.25 1.25h-7.188l-12.5-12.5 7.135-7.134a1.25 1.25 0 011.769 0L60.5 43.159V49.5a1.25 1.25 0 01-1.25 1.25zM38 18.25a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z",
    fill: "#CDCBD4"
  })));
}

export default SvgImagePlaceholder;